module.exports = function () {
  const myVideos = document.querySelectorAll('.inview-video');
  const observerConfig = {
    rootMargin: '0px'
  };

  const videoObserver = new IntersectionObserver( function(entries) {
    entries.forEach( function(entry) {
      if (entry.intersectionRatio > 0) {
        playVideo(entry.target);
      } else {
        pauseVideo(entry.target);
      }
    });
  }, observerConfig);

  myVideos.forEach( function(video) {
    videoObserver.observe(video);
  });

  function playVideo(video) {
    video.play();
  }

  function pauseVideo(video) {
    video.pause();
  }
}
